import { render, staticRenderFns } from "./defaultArticleContent.vue?vue&type=template&id=4d4f07dd&scoped=true&"
import script from "./defaultArticleContent.vue?vue&type=script&lang=js&"
export * from "./defaultArticleContent.vue?vue&type=script&lang=js&"
import style0 from "./defaultArticleContent.vue?vue&type=style&index=0&id=4d4f07dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4f07dd",
  null
  
)

component.options.__file = "defaultArticleContent.vue"
export default component.exports